export default {
  title: '兑换记录',
  giftInfo: '礼品信息',
  giftInfoPlaceholder: '请输入关键词搜索',
  memberInfo: '会员信息',
  memberInfoPlaceholder: '请输入关键词搜索',
  shipStatus: '发货状态',
  exchangeTime: '兑换时间',
  startDate: '开始时间',
  endDate: '结束时间',
  country: '国家',
  exchangePrice: '兑换价格',
  exchangeQty: '兑换数量',
  contactPhone: '联系电话',
  shippingAddress: '收货地址',
  spec: '规格',
  specName: '规格',
  singleSpec: '单规格',
  statusPending: '待处理',
  statusShipped: '已发货',
  statusAll: '全部',
  statusRedeemed: '已兑换',
  statusCompleted: '已完成',
  statusCancelled: '已取消',
  statusFailed: '失败',
  ship: '发货',
  detail: '详情',
  shipModalTitle: '发货',
  shipDetailTitle: '发货信息',
  expressCompany: '快递公司',
  expressCompanyPlaceholder: '请输入快递公司名称',
  trackingNo: '物流单号',
  trackingNoPlaceholder: '请输入物流单号',
  remark: '备注',
  remarkPlaceholder: '请输入备注',
  expressCompanyRequired: '请输入快递公司',
  trackingNoRequired: '请输入物流单号',
  timeRequired: '请选择兑换时间',
};
